import classNames from 'classnames';

/**
 * The only affordance for a scrolling table besides the arrow buttons —
 * scrollbars are hidden repo-wide by `scrollbar-none`. Built from `--fill-card`
 * so it reads as the content fading rather than as an overlay.
 */
export const TableEdgeFade = (props: {
  side: 'left' | 'right';
  show: boolean;
}) => (
  <div
    aria-hidden="true"
    className={classNames(
      'pointer-events-none absolute inset-y-0 z-40 w-8 transition-opacity duration-200',
      props.side === 'right' ? 'right-0' : 'left-0',
      props.show ? 'opacity-100' : 'opacity-0',
    )}
    style={{
      background: `linear-gradient(to ${
        props.side === 'right' ? 'left' : 'right'
      }, var(--fill-card), transparent)`,
    }}
  />
);
